import { useMemo } from "react"
import _ from "lodash"
import { EXTENSION_NAME } from "../../constants"
import { useExtension } from "hooks/extension/useExtension"
import { IConfigIcon } from "utils/icon"

export interface IHomeInstructionCard {
  key: string
  icon: IConfigIcon
  label: string
  subLabel: string
}

interface IUseHomeInstructionCards {
  enable: boolean
  cards: IHomeInstructionCard[]
}

export const useHomeInstructionCards = (): IUseHomeInstructionCards => {
  const { extensionConfig } = useExtension()

  return useMemo(() => {
    const base = `${EXTENSION_NAME}.options.home.instructionCards`

    return {
      enable: _.get(extensionConfig, `${base}.enable`, false) as boolean,
      cards: _.get(
        extensionConfig,
        `${base}.cards`,
        []
      ) as IHomeInstructionCard[],
    }
  }, [extensionConfig])
}
